import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import {
    Buildings, Users, ChartLineUp, SignOut, Stack, Lifebuoy, CreditCard, Palette, CurrencyInr, Headset, Sparkle, EnvelopeSimple, Receipt,
} from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const nav = [
    { to: "/platform", label: "Overview", icon: ChartLineUp, end: true, testid: "platform-nav-overview" },
    { to: "/platform/organizations", label: "Organizations", icon: Buildings, testid: "platform-nav-orgs" },
    { to: "/platform/payments", label: "Payments", icon: Receipt, testid: "platform-nav-payments" },
    { to: "/platform/billing", label: "Payment gateway", icon: CreditCard, testid: "platform-nav-billing" },
    { to: "/platform/pricing", label: "Pricing", icon: CurrencyInr, testid: "platform-nav-pricing" },
    { to: "/platform/templates", label: "Templates", icon: Sparkle, testid: "platform-nav-templates" },
    { to: "/platform/email-settings", label: "Email", icon: EnvelopeSimple, testid: "platform-nav-email" },
    { to: "/platform/demo-requests", label: "Demo Requests", icon: Headset, testid: "platform-nav-demo-requests" },
    { to: "/platform/themes", label: "Themes", icon: Palette, testid: "platform-nav-themes" },
];

export default function PlatformLayout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const handleLogout = async () => { await logout(); navigate("/login"); };

    return (
        <div className="min-h-screen flex bg-background">
            <aside className="w-64 border-r border-border bg-foreground text-background flex flex-col" data-testid="platform-sidebar">
                <div className="p-6 border-b border-background/15">
                    <div className="label-overline mb-1 text-background/60">FormFlo · Platform</div>
                    <div className="text-xl font-display font-bold tracking-tight">FormFlo<span className="text-warning">.</span></div>
                </div>
                <div className="px-6 py-4 border-b border-background/20">
                    <div className="label-overline mb-1 text-background/60">Operator</div>
                    <div className="text-sm font-medium truncate" data-testid="platform-user-name">{user?.name}</div>
                    <div className="text-xs text-background/60 truncate">{user?.email}</div>
                </div>
                <nav className="flex-1 p-3 space-y-1">
                    {nav.map((it) => (
                        <NavLink
                            key={it.to} to={it.to} end={it.end} data-testid={it.testid}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-3 py-2 rounded-sm text-sm transition-colors ${
                                    isActive ? "bg-warning text-foreground" : "hover:bg-background/10"
                                }`
                            }
                        >
                            <it.icon size={18} weight="duotone" />
                            <span>{it.label}</span>
                        </NavLink>
                    ))}
                </nav>
                <div className="p-3 border-t border-background/20 space-y-2">
                    <Button variant="outline" size="sm" className="w-full justify-start rounded-sm bg-transparent border-background/20 text-background hover:bg-background/10 hover:text-background" onClick={() => navigate("/dashboard")} data-testid="exit-platform-btn">
                        <Stack size={16} className="mr-2" /> Exit to org app
                    </Button>
                    <Button variant="outline" size="sm" className="w-full justify-start rounded-sm bg-transparent border-background/20 text-background hover:bg-background/10 hover:text-background" onClick={handleLogout} data-testid="platform-logout-btn">
                        <SignOut size={16} className="mr-2" /> Sign out
                    </Button>
                </div>
            </aside>
            <main className="flex-1 overflow-auto">
                <Outlet />
            </main>
        </div>
    );
}
